<template>
  <div class="dedicatedHostingResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px">
      <div v-if="companyIdShow == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            @on-change="changeCompanyID"
            placeholder="公司"
            :transfer="true"
          >
            <Option
              v-for="item in companyIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <!--按账户筛选  -->
        <Select
          v-model="accountIdList"
          filterable
          multiple
          :max-tag-count="1"
          placeholder="请输入账户"
          @on-change="changeAccountId(accountIdList)"
          :transfer="true"
        >
          <Checkbox
            v-model="singleAccount"
            @on-change="selectAccountAll"
            style="display: block; text-align: right"
            v-if="accountList.length > 0"
            >{{ $t("alarms.common.allSelected") }}</Checkbox
          >
          <Option :value="item.id" v-for="item in accountList" :key="item.id">{{
            item.name
          }}</Option>
        </Select> </Col
      ><Col span="6">
        <Input
          v-model="hostId"
          :placeholder="$t('RAM.AWS.DedicatedHosting.hostId')"
        />
      </Col>
      <Col span="2">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:dedicatedHostingResource:page'
          ]"
          @click="search()"
          >{{ $t("alarms.common.search") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableDedicatedHostingResource from "../bsh/TableDedicatedHostingResource";
var tableDedicatedHostingResource = TableDedicatedHostingResource;
export default {
  name: "DedicatedHostingResourceSearch",
  data() {
    return {
      companyIdShow: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountSearchID: "",
      singleAccount: false,
      accountIdList: [],
      accountList: [],
      hostId: ""
    };
  },
  mounted: function() {
    if (this.companyIdShow == 1) {
      this.listCompanys();
    } else {
      this.companyId = this.companyIdShow;
      // 根据公司查询当前账号列表
      this.getAWSAccountByCompanyId();
      // 默认查询列表
      // tableDedicatedHostingResource.methods.showAll();
    }
  },
  methods: {
    //查询账号
    listCompanys: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        // 根据公司查询当前账号列表
        this.getAWSAccountByCompanyId();
        // 默认查询列表
        // tableDedicatedHostingResource.methods.showAll();
        // this.accountSearchKey = [];
      });
    },
    // 根据公司id获取当前公司下的账号列表
    getAWSAccountByCompanyId: function() {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountIdList.push(this.accountList[i].id);
            }
          }
        });
    },
    // 切换公司
    changeCompanyID: function() {
      this.accountIdList = [];
      this.getAWSAccountByCompanyId();
    },
    // 切换账户
    changeAccountId: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll() {
      this.accountIdList = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountIdList.push(item.id);
        });
      } else {
        this.accountIdList = [];
      }
    },
    search: function() {
      eventBus.$emit("hostId", this.hostId);
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountIdList", this.accountIdList);
      tableDedicatedHostingResource.methods.showAll();
    }
  }
};
</script>
<style scoped>
.dedicatedHostingResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/bsh/DedicatedHostingResourceSearch.vue